import { useEffect } from "react";
export var useMount = function (callback) {
    useEffect(function () {
        callback();
    }, []);
};
